import videojs from 'video.js';

export class IFramePluginStub extends videojs.getPlugin('plugin') {
    constructor(player, options) {
        super(player, options);

        player.loader().onLoadPlayCover(onLoadPlayCover.bind(player));
    }
}

function shouldLoad(presentationId, playCoverData, presentationData) {
    return window.parent !== window;
}

async function onLoadPlayCover(presentationId, playCoverData, presentationData) {
    const player = this;
    const { allowedPlayerIFrameAPISites } = playCoverData;
    if (shouldLoad(...arguments)) {
        if (!videojs.getPlugin('iframe')) {
            const { IFramePlugin } = await import(/* webpackChunkName: 'iframe' */ './iframe.js');
            player.registerPlugin('iframe', IFramePlugin);
        }
        
        player.iframe().init({ allowedPlayerIFrameAPISites });
    }
}
